<div [class.active]="isFocus" class="title">{{title}}</div>
<input #inputEl [ngClass]="[isExistCat ? 'existCat' : '']" autofocus [(ngModel)]="model" [placeholder]="placeholder"
       (input)="onInput($event)" [style.width]="textboxWidth" (focus)="isFocus=true" (blur)="onBlur()"
       (keyup.enter)="onEnter()" [class.active]="isFocus" [disabled]="disabled"
       [matTooltip]="tooltip ? tooltip : null" />
<div class="error-container">
       <div class="error" [class.visible]="!isValid && errorMessage.length > 0">
              {{ errMssg }}
       </div>
</div>